// import { Row } from 'ant-design-vue'
import viewsSentOrder from '../components/viewPage.vue'
import editUnconfirmedOrder from './../components/editDeliveriesTakedOrder.vue'
// import orderConfirmed from '../components/orderConfirmed.vue'
// import editSentOrder from '../components/editSentOrder.vue'
import store from '../../store'
// import saleVerify from './../components/saleVerify.vue'
// import saleVerify1 from './../components/saleVerify1.vue'
import verifyLog from './../components/verifyLog.vue'
import orderStatus from '../components/orderStatus.vue'
import NP from 'number-precision'
// import DeleteOrder from './../components/orderDelete.vue'

export default {
  className: 'Order', // 待一审订单
  title: '待二审订单',
  perPage: 30,
  mixin: {
    fields: [
      // {
      //   name: 'Number'
      // },
      {
        // 所属用户
        name: 'userid',
        note: '销售人员',
        width: 80,
        validators: [
          val => (val) ? null : '所属用户不可为空'
        ]
      },
      {
        name: 'userCompany',
        note: '所属公司',
        width: 80,
        validators: [
          val => (val) ? null : '所属公司不可为空'
        ]
      },
      {
        // 型号
        name: 'finishProductid',
        width: 80,
        validators: [
          val => (val) ? null : '成品型号不可为空'
        ]
      },
      {
        // 所属车间型号
        name: 'modelId',
        note: '车间型号',
        width: 80,
        render: (record) => {
          return `${record.finishProductid.model.name}`
        },
      },
      {
        // 包装
        name: 'packid',
        width: 80,
      },
      {
        // 托盘
        name: 'palletid',
        width: 80,
      },
      {
        // 状态
        name: 'status',
        width: 100,
        view: {
          component: orderStatus
        }
      },

      {
        name: 'verifyStatus',
        width: 100,
      },
      {
        // 麦头
        name: 'markid',
        width: 80,
      },
      {
        // 订单客户
        name: 'clientid',
        width: 110
      },
      {
        // 吨数
        name: 'amount',
        width: 80,
      },
      {
        // 运费
        name: 'shipping',
        width: 80,
      },
      {
        // 每吨运费
        name: 'pricePerTon',
        width: 100,
      },
      {
        // 售价
        name: 'sellingPrice',
        width: 80,
      },
      {
        // 成本
        name: 'costPrice',
        width: 80,
      },
      {
        // 客户提成
        name: 'clientCommission',
        width: 100,
      },
      {
        name: 'taxRate',
        width: 80,
      },
      {
        // 下单日期
        name: 'orderDate',

      },
      {
        // 发出时间
        name: 'sentAt',

      },
      {
        // 交付日期
        name: 'shipDate',

      },
      {
        // 利润
        name: 'profit',
        width: 80,
        validators: [
          val => (val) ? null : '利润不可为空'
        ],
        hidden: () => true
      },

      {
        // 备注
        name: 'remarks',
        width: 80,
      },

      {
        // 提成
        name: 'commission',
        width: 80,
        validators: [
          val => (val) ? null : '提成不可为空'
        ],
        hidden: () => true
      },
      // {
      //   // 其他费用
      //   name: 'anotherCost'
      // },
      {
        name: 'updatedAt',

      }
    ],
  },
  search: [
    'userid',
    'userCompany',
    'finishProductid',
    'orderDate',
    'shipDate'
  ],
  action: {
    create: false,
    // edit: store.state.user && ((store.state.user.adminRole === 'sale') || (store.state.user.adminRole === 'admin'))
    //   ? {
    //     type: 'row',
    //     text: '编辑',
    //     component: editSentOrder
    //   } : false,
    edit: store.state.user && store.state.user.authority.unconfirmedOrder2.edit
      ? {
        type: 'row',
        text: '编辑',
        title: '订单编辑',
        component: editUnconfirmedOrder
      } : false,
    view: store.state.user && store.state.user.authority.unconfirmedOrder2.view ? {
      type: 'row',
      text: '查看',
      component: viewsSentOrder,
    } : false,
    verify2: store.state.user && store.state.user.authority.unconfirmedOrder2.verify2
      ? {
        type: 'row',
        text: '审核',
        callback: async ({ record, vm, modelName }) => {
          await vm.confirm('提示', '确认对此订单进行二次审核？')
          let rs = null
          let data = {
            verifyStatus: record.verifyStatus, // 审核状态
            status: record.status, // 订单状态
            auditor2: '', // 二审人
            verifyDate2: '' // 二审日期
          }
          let commonData = {
            sentAt: record.sentAt, // 订单的发出时间
            amount: record.amount, // 吨数
            finishProductid: record.finishProductid.objectId, // 型号
            costPrice: record.costPrice, // 成本
            orderSalaryP: null, // 订单工资P
            orderSalaryT: null, // 订单工资T
            profitP: null, // 利润P
            profitT: null, // 利润T
            realProfit: null, // 实际利润
            userId: record.userid.objectId ? record.userid.objectId : '', // 用户
            clientid: record.clientid.objectId, // 客户
            userCompany: record.userCompany.objectId, // 用户所属公司
            sellingPrice: record.sellingPrice, // 售价
            realSalary: null // 实际工资
          }
          let salaryData = {
            totalPrice: null,
            amountCommission: null, // 吨提成
            amountRatio1: record.shopManagementid.workShop.amountRatio1 ? record.shopManagementid.workShop.amountRatio1 : null, // 车间吨系数
            amountRatio2: record.finishProductid.model.amountRatio2 ? record.finishProductid.model.amountRatio2 : null, // 大类吨系数
            profitRatio1: record.shopManagementid.workShop.profitRatio1 ? record.shopManagementid.workShop.profitRatio1 : null, // 车间利系数
            profitRatio2: record.finishProductid.model.profitRatio2 ? record.finishProductid.model.profitRatio2 : null// 大类利系数
          }
          let profitData = {
            idProfit: null, // 型号利润
            taxRate: record.taxRate, // 税率
            tax: null, // 税额
            shipping: record.shipping, // 运费
            TCH: record.clientCommission, // 客户提成
            packid: record.packid.objectId, // 包装
            palletid: record.palletid.objectId, // 托盘
            profitR: null // 订单利润R
          }
          let orderProfit = null
          let { data: res } = await vm.$modelAjax.get('surcharge', {
            params: {
              where: {
                proportion: record.finishProductid.proportion.objectId,
                type: 'finish'
              }
            }
          })
          console.log('rrres', res)
          orderProfit = res.results.length ? res.results[0].profit : 0
          profitData.idProfit = orderProfit
          if (data.verifyStatus === 'firstVerify') {
            if (salaryData.amountRatio1 && salaryData.amountRatio2 && salaryData.profitRatio1 && salaryData.profitRatio2) {
              data.verifyStatus = 'secondVerify'
              data.auditor2 = store.state.user.name
              data.verifyDate2 = new Date().toISOString()
              if (record.status === 'deliveriesTaked') { data.status = 'finish' }
              // 获取吨提成基数
              let { data: res1 } = await vm.$tkParse.get('/settings')
              let amountCommissionRadix = res1.amountCommission
              // 计算
              salaryData.totalPrice = NP.round(NP.times(record.sellingPrice, commonData.amount), 2)
              profitData.tax = NP.round(NP.times(record.sellingPrice, record.taxRate), 2)
              salaryData.amountCommission = NP.round(NP.times(amountCommissionRadix, salaryData.amountRatio1, salaryData.amountRatio2), 2)
              commonData.orderSalaryP = NP.round(NP.divide(NP.times(NP.minus(record.sellingPrice, NP.times(record.taxRate, record.sellingPrice), record.pricePerTon, record.clientCommission, record.packid.price, record.palletid.price, record.costPrice), NP.times(salaryData.profitRatio1, salaryData.profitRatio2, commonData.amount)), NP.plus(1, NP.times(salaryData.profitRatio1, salaryData.profitRatio2, commonData.amount))), 2)
              commonData.orderSalaryT = NP.round(NP.times(salaryData.amountCommission, commonData.amount), 2)
              commonData.profitP = NP.round(NP.minus(NP.minus(commonData.sellingPrice, NP.times(commonData.sellingPrice, record.taxRate), record.pricePerTon, record.clientCommission, record.packid.price, record.palletid.price, commonData.orderSalaryP), record.costPrice), 2)
              commonData.profitT = NP.round(NP.minus(NP.minus(commonData.sellingPrice, NP.times(commonData.sellingPrice, record.taxRate), record.pricePerTon, record.clientCommission, record.packid.price, record.palletid.price, commonData.orderSalaryT), record.costPrice), 2)
              // commonData.realProfit = NP.round(Math.min(NP.plus(commonData.profitP, NP.times(orderProfit, commonData.amount)), NP.plus(commonData.profitT, NP.times(orderProfit, commonData.amount))), 2)
              // commonData.realProfit = NP.round(Math.min(NP.times(NP.plus(commonData.profitP, orderProfit), commonData.amount), NP.plus(commonData.profitT, NP.times(orderProfit, commonData.amount))), 2)
              commonData.realProfit = NP.round(NP.minus(NP.times(NP.minus(record.sellingPrice, profitData.tax, profitData.TCH, record.packid.price, record.palletid.price, record.costPrice), commonData.amount), record.shipping, Math.max(commonData.orderSalaryP, commonData.orderSalaryT)), 2)
              profitData.profitR = NP.round(NP.plus(commonData.realProfit, NP.times(NP.plus(orderProfit, record.finishProductid.adjustment), record.amount)), 2)
              commonData.realSalary = Math.max(commonData.orderSalaryP, commonData.orderSalaryT)
              await vm.$modelAjax.post('salary', { ...commonData, ...salaryData })
              await vm.$modelAjax.post('profit', { ...commonData, ...profitData })

              try {
                // console.log(data, commonData, salaryData, profitData)
                rs = await vm.$modelAjax.put('Order', record.objectId, data)
              } catch (e) {
                vm.$notification.error({
                  message: '网络错误',
                  description: '网络错误'
                })
              }
            } else {
              vm.$notification.error({
                message: '计算错误',
                description: '车间系数或大类系数异常'
              })
            }
          } else if (data.verifyStatus === 'secondVerify') {
            vm.$notification.error({
              message: '订单已审核',
              description: '此订单已完成二次审核'
            })
          } else {
            vm.$notification.error({
              message: '审核失败',
              description: '此订单不可进行二次审核'
            })
          }
          if (rs) {
            vm.$notification['success']({
              message: '操作成功',
              description: '此订单已完成二次审核'
            })
            vm.refresh()
          }
        }
        // component: saleVerify
      } : false,
    log: store.state.user && store.state.user.authority.unconfirmedOrder2.log
      ? {
        type: 'row',
        text: '审核日志',
        title: '审核日志',
        component: verifyLog
      } : false,
    delete: false
  },
  hooks: {
    beforeFetch ({ where }) {
      // where.status = 'transit'
      where.status = {
        $in: ['transit', 'deliveriesTaked']
      }
      where.verifyStatus = {
        $in: ['firstVerify']
      }
      where.isReserve = { $ne: true }
      if (store.state.user && store.state.user.allShopManagements === 'Yes') {

      } else {
        // where.shopManagementid = {
        //   $in: store.state.user.shopManagements
        // }
        where.finishProductid = {
          $inQuery: {
            where: {
              workShop: {
                $inQuery: {
                  where: {
                    objectId: { $in: store.state.user.shopManagements }
                  },
                  className: 'shopManagement'
                }
              }
            },
            className: 'finishProduct'
          }
        }
      }
      if (store.state.user && store.state.user.allClient === 'Yes') { } else {
        where.userid = store.state.user.objectId
      }
    }
  }
}
